<template>
  <LayoutDefault class="">
    <section class="events">
      <div class="events-header">
        <h1>Мероприятия</h1>
        <hr>
      </div>

      <div class="events__tools">
        <h2 class="events__tools-title">Поиск мероприятия:</h2>

        <div class="events__tools-items">
          <div class="events__tools-search">ПBygen</div>
          <div class="events__tools-buttons">
            <ToolbarIcons type-img="plus" @click-icon="$emit('clickPlus')"/>
            <ToolbarIcons
              type-img="copy"
              @click-icon="$emit('clickCopy')"
              :disabled="selectedRowTable === 0"
            />
            <ToolbarIcons
              type-img="trash"
              @click-icon="$emit('clickTrash')"
              :disabled="selectedRowTable === 0"
            />
          </div>
        </div>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
// import { ref } from 'vue'
import LayoutDefault from '@/layout/LayoutDefault'
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'

export default {
  name: 'GroupLearningEditorViewNew',
  components: {
    LayoutDefault,
    ToolbarIcons
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.events {
  &-header {
    display: flex;
    align-items: center;
    gap: 11px;

    hr {
      flex: 1;
      border: 1px solid #C8C8C8;
    }
  }

  &__tools {
    &-items {
      display: flex;
    }

    &-buttons {
      display: flex;
    }
  }
}
</style>
